"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack, Icon, Text } from "@chakra-ui/react";
import { Lock, User, Building, Folder, Link as LinkIcon, Percentage, Gift, } from "iconoir-react";
const VARIABLE_ICONS = {
    first_name: User,
    brand_name: Building,
    program_name: Folder,
    affiliate_link: LinkIcon,
    discount_code: Gift,
    commission_rate: Percentage,
};
const DefaultIcon = User;
function VariableIcon({ variableKey }) {
    const IconComponent = VARIABLE_ICONS[variableKey] || DefaultIcon;
    return (_jsx(Icon, { asChild: true, boxSize: 3.5, color: "fg.muted", flexShrink: 0, children: _jsx(IconComponent, {}) }));
}
/**
 * Presentational component that renders a single variable option row.
 *
 * Used by both `VariableDropdownPlugin` (inside a Combobox.Item) and
 * `VariableTypeaheadPlugin` (inside a raw `<div>` with a Lexical ref).
 */
export function VariableOptionItem({ label, variableKey, isDisabled = false, disabledReason, noDataLabel = "No data available", pointerEventsNone = false, }) {
    return (_jsxs(HStack, { gap: 2, opacity: isDisabled ? 0.5 : 1, w: "full", align: "center", pointerEvents: pointerEventsNone ? "none" : undefined, children: [_jsx(VariableIcon, { variableKey: variableKey }), _jsxs("div", { children: [_jsx(Text, { fontWeight: "medium", fontSize: "xs", lineHeight: "tight", children: label }), _jsx(Text, { fontSize: "2xs", color: "fg.muted", fontFamily: "mono", lineHeight: "tight", children: `{{${variableKey}}}` }), isDisabled ? (_jsxs(HStack, { gap: 1, children: [_jsx(Lock, { width: 10, height: 10 }), _jsx(Text, { fontSize: "2xs", color: "red.fg", children: disabledReason || noDataLabel })] })) : null] })] }));
}
